// --- Create a dedicated AnalyticsTracker component (e.g., AnalyticsTracker.js/tsx) ---
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // <-- useLocation is used here
import { logEvent } from "firebase/analytics";
import { analytics } from './firebase'; // Assuming you exported analytics from firebase.js

function AnalyticsTracker() {
  const location = useLocation(); // This hook now works because AnalyticsTracker is rendered inside BrowserRouter

  useEffect(() => {
    // Log the screen_view event whenever the location changes
    if (analytics) {
      console.log('Logging screen view for:', location.pathname); // Optional: for debugging
      logEvent(analytics, 'screen_view', {
        screen_name: location.pathname,
        screen_class: 'ReactApp', // Or whatever name you like
        page_location: window.location.href
      });
    }
  }, [location]); // Dependency array: re-run effect when location changes

  // This component doesn't need to render anything visible
  return null;
}

export default AnalyticsTracker;